{
  "/databases/": {},
  "/jobs/": {
    "read": [
      "public"
    ],
    "create": [
      "public"
    ],
    "update": [
      "public"
    ],
    "delete": [
      "public"
    ]
  },
  "/urls/": {
    "read": [
      "public"
    ],
    "create": [
      "public"
    ],
    "update": [
      "public"
    ],
    "delete": [
      "public"
    ]
  },
  "/assets/": {
    "read": [
      "public"
    ],
    "create": [
      "public"
    ],
    "update": [
      "public"
    ],
    "delete": [
      "public"
    ]
  },
  "/_githubPRs/": {
    "read": [
      "public"
    ],
    "create": [
      "public"
    ],
    "update": [
      "public"
    ],
    "delete": [
      "public"
    ]
  },
  "/_hostingChannels/": {
    "read": [
      "public"
    ],
    "create": [
      "public"
    ],
    "update": [
      "public"
    ],
    "delete": [
      "public"
    ]
  },
  "/settings/App Settings ": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "manager",
      "admin"
    ],
    "create": [
      "public"
    ],
    "delete": [
      "admin"
    ]
  },
  "/settings/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "manager",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/roles/": {
    "read": [
      "admin",
      "manager",
      "callAgent",
      "cases"
    ],
    "create": [
      "admin",
      "manager"
    ],
    "update": [
      "admin",
      "manager"
    ],
    "delete": [
      "admin",
      "manager"
    ]
  },
  "/profiles/": {
    "read": [
      "admin",
      "manager",
      "accounts",
      "callAgent",
      "cases"
    ],
    "create": [
      "admin"
    ],
    "update": [
      "admin"
    ],
    "delete": []
  },
  "/telephonySessions/": {
    "read": [
      "callAgent",
      "admin",
      "manager"
    ],
    "create": [
      "callAgent",
      "admin",
      "manager"
    ],
    "update": [
      "callAgent",
      "admin",
      "manager"
    ],
    "delete": [
      "callAgent",
      "admin",
      "manager"
    ]
  },
  "/messages/": {
    "read": [
      "callAgent",
      "admin",
      "manager"
    ],
    "create": [
      "callAgent",
      "admin",
      "manager"
    ],
    "update": [
      "callAgent",
      "admin",
      "manager"
    ],
    "delete": [
      "callAgent",
      "admin",
      "manager"
    ]
  },
  "/extensions/": {
    "read": [
      "callAgent",
      "admin",
      "manager"
    ],
    "create": [
      "admin",
      "manager"
    ],
    "update": [
      "admin",
      "manager"
    ],
    "delete": [
      "admin",
      "manager"
    ]
  },
  "/fcmTokens/": {
    "read": [],
    "create": [],
    "update": [],
    "delete": []
  },
  "/notifications/": {
    "read": [],
    "create": [],
    "update": [],
    "delete": []
  },
  "/collections/": {
    "read": [],
    "create": [],
    "update": [],
    "delete": []
  },
  "/content/": {
    "read": [],
    "create": [],
    "update": [],
    "delete": []
  },
  "/submissions/": {
    "read": [
      "submissions",
      "content",
      "admin",
      "cases"
    ],
    "create": [
      "submissions",
      "content",
      "admin",
      "cases"
    ],
    "update": [
      "submissions",
      "content",
      "admin",
      "cases"
    ],
    "delete": [
      "submissions",
      "content",
      "admin",
      "cases"
    ]
  },
  "/calls/": {
    "read": [
      "submissions",
      "content",
      "admin",
      "callAgent"
    ],
    "create": [
      "submissions",
      "content",
      "admin",
      "callAgent"
    ],
    "update": [
      "submissions",
      "content",
      "admin",
      "callAgent"
    ],
    "delete": [
      "submissions",
      "content",
      "admin",
      "callAgent"
    ]
  },
  "/contacts/": {
    "read": [
      "submissions",
      "content",
      "admin"
    ],
    "create": [
      "submissions",
      "content",
      "admin"
    ],
    "update": [
      "submissions",
      "content",
      "admin"
    ],
    "delete": [
      "submissions",
      "content",
      "admin"
    ]
  },
  "/cases/": {
    "read": [
      "submissions",
      "content",
      "admin",
      "cases"
    ],
    "create": [
      "submissions",
      "content",
      "admin",
      "cases"
    ],
    "update": [
      "submissions",
      "content",
      "admin",
      "cases"
    ],
    "delete": [
      "submissions",
      "content",
      "admin",
      "cases"
    ]
  },
  "/caseMetricAdjustments/": {
    "read": [
      "submissions",
      "content",
      "admin"
    ],
    "create": [
      "submissions",
      "content",
      "admin"
    ],
    "update": [
      "submissions",
      "content",
      "admin"
    ],
    "delete": [
      "submissions",
      "content",
      "admin"
    ]
  },
  "/documents/": {
    "read": [
      "callAgent",
      "admin",
      "manager"
    ],
    "create": [
      "callAgent",
      "admin",
      "manager"
    ],
    "update": [
      "callAgent",
      "admin",
      "manager"
    ],
    "delete": [
      "callAgent",
      "admin",
      "manager"
    ]
  },
  "/scripts/": {
    "read": [
      "callAgent",
      "admin",
      "manager"
    ],
    "create": [
      "callAgent",
      "admin",
      "manager"
    ],
    "update": [
      "callAgent",
      "admin",
      "manager"
    ],
    "delete": [
      "callAgent",
      "admin",
      "manager"
    ]
  },
  "/envelopes/": {
    "read": [
      "admin",
      "manager",
      "envelopes",
      "content"
    ],
    "create": [
      "admin",
      "manager",
      "envelopes",
      "content"
    ],
    "update": [
      "admin",
      "manager",
      "envelopes",
      "content"
    ],
    "delete": [
      "admin",
      "manager",
      "envelopes",
      "content"
    ]
  },
  "/templates/": {
    "read": [
      "admin",
      "manager"
    ],
    "create": [
      "admin",
      "manager"
    ],
    "update": [
      "admin",
      "manager"
    ],
    "delete": [
      "admin",
      "manager"
    ]
  },
  "/home/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/about/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/about us/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/practice areas/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/testimonials/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/location/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/our services/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/our locations/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/my projects/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/schedule/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/blog/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/news/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/operate/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/audience/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/scholarships/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/total loss/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/contact/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/contact us/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/authorization form/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/free estimate/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/referral/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/rental car waiver/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/vehicle report/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/remote/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/posts/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/articles/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/services/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/locations/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/projects/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/events/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/forms/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/terms of service/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/privacy policy/": {
    "read": [
      "public"
    ],
    "update": [
      "content",
      "admin"
    ],
    "create": [
      "admin"
    ],
    "delete": [
      "admin"
    ]
  },
  "/": {
    "read": [],
    "create": [],
    "update": [],
    "delete": []
  }
}